import React from 'react';
import {DownloadCsvButton} from '@igp/shared/components/download';
import type {UseDownloadProps, UseDownloadResult} from '@igp/shared/redux/download';
import {useDownload} from '@igp/shared/redux/download';

import {CountryLevelPartnerReportServiceTypes, type CountryLevelPartnerReportViewModelKeys} from '../types';

import {localized} from './DataGrid';

type UseCountryLevelPartnerReportDownloadProps = Pick<
    UseDownloadProps<CountryLevelPartnerReportViewModelKeys>,
    'filename' | 'keys' | 'mode' | 'filter' | 'total' | 'hasSummary'
>;

export function useCountryLevelPartnerReportDownload(props: UseCountryLevelPartnerReportDownloadProps): UseDownloadResult {
    const {handleDownload, isProgress} = useDownload<CountryLevelPartnerReportViewModelKeys>({
        ...props,
        strategySymbol:
            props.mode === 'client'
                ? CountryLevelPartnerReportServiceTypes.downloadClientStrategy
                : CountryLevelPartnerReportServiceTypes.downloadServerStrategy,
        headersLocalization: localized,
    });

    return {handleDownload, isProgress};
}

export type CountryLevelPartnerReportDownloadCsvButtonProps = UseCountryLevelPartnerReportDownloadProps & {
    disabled: boolean;
};

export function CountryLevelPartnerReportDownloadCsvButton({
    disabled,
    filename,
    total,
    keys,
    filter,
    mode,
    hasSummary,
}: CountryLevelPartnerReportDownloadCsvButtonProps) {
    const {handleDownload, isProgress} = useCountryLevelPartnerReportDownload({filename, total, keys, filter, mode, hasSummary});
    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={isProgress || disabled} />;
}
